import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Configurazione} from "../../models/configurazione";
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import {filter} from "rxjs/operators";
import { Subject, take } from 'rxjs';
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  Documento, Rata
} from "../../models/payment-notices-response";
import {PaymentnoticesService} from "../../services/paymentnotices.service";
import { ActivatedRoute, Router } from '@angular/router';
import {MessageService} from "../../services/message.service";
import {UserData} from "../../models/user-data";
import {AccountService} from "../../core/auth/account.service";
import {AlertService} from "../../shared/alert/alert.service";
import { AmministrazioneService } from '../../services/amministrazione.service';
import { PnFunzioneServizio } from '../../models/servizio';

@Component({
  selector: 'jhi-pagamento-tributi',
  templateUrl: './pagamento-tributi.component.html',
  styleUrls: ['./pagamento-tributi.component.scss']
})
export class PagamentoTributiComponent extends SubscriptionManager implements OnInit, AfterViewInit {
  loading: boolean;
  curIndex: number;
  configurazione!: Configurazione;
  checkBoxPrivacy: boolean;
  countFiltri: number;
  listaPagamenti: Array<Documento>;
  windowSize: number;
  formFilter!: FormGroup;
  listaPagamentiNoSort: Array<Documento>;
  paginaCorrente: number;
  totalPages: number;
  isIuvPresent = false;
  enter: boolean;
  @Input() id!: string;
  @Input() maxSize!: number;
  userData!: UserData;
  stepIndex = 0;
  isChecked = false;
  pagamentoSelezionato?: Documento;
  rataSubject: Subject<Rata> = new Subject<Rata>();
  cdTributo: string = '';
  numeroTributo?: number;
  funzioneServizio!: PnFunzioneServizio;

  constructor(private ammService: AmministrazioneService, protected confService: ConfigurazioneGeneraleService, private alertService: AlertService, private accountService: AccountService, protected paymentNoticesService: PaymentnoticesService, private _fb: FormBuilder, private router: Router, private messageService: MessageService, private activatedRoute: ActivatedRoute) {
    super();
    this.loading = false;
    this.curIndex = 0;
    this.checkBoxPrivacy = false;
    this.countFiltri = 0;
    this.listaPagamenti = [];
    this.listaPagamentiNoSort = [];
    this.windowSize = window.length;
    this.countFiltri = 0;
    this.paginaCorrente = 0;
    this.totalPages = 1;
    this.enter = true;
  }

  ngOnInit(): void {
    this.subs.sink = this.confService.configurazione$
      .pipe(filter(configurazione => configurazione !== null), take(1))
      .subscribe(configurazione => {
        this.configurazione = configurazione!;
      });
    this.formFilter = this._fb.group({
       iuv: [null],
       stato: [null],
       numEl: [10]
    });
    this.cdTributo = this.activatedRoute.snapshot.params["cdTributo"];
    this.numeroTributo = this.activatedRoute.snapshot.params["numero"];
    this.subs.sink = this.ammService.pnFunzioneServizioByCdFunzione(this.cdTributo).subscribe({
      next: (res) => {
        this.funzioneServizio = res;
      }
    })
  }

  ngAfterViewInit():void {
    this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}');
    if(this.userData?.cf){
      this.richiestaPosizioniTributarie();
    }else{
      this.accountService.loggedSubject.subscribe(() => {
        this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}');
        this.richiestaPosizioniTributarie();
      })
    }
  }

  goToPaga():void{
    if(this.pagamentoSelezionato?.Rate && this.pagamentoSelezionato.Rate.length > 1){
      console.log("To Implement")
    }else{
      this.rataSubject.next(this.pagamentoSelezionato!.Rate[0]);
    }
  }

  checkValidazioneStep(): boolean {
    if (this.curIndex === 0) {
      return !this.checkBoxPrivacy;
    }else {
      return false;
    }
  }

  checkIuvPresent():void{
    this.isIuvPresent = false;
    this.listaPagamenti.forEach((pg) => {
      if(pg.Iuv){
        this.isIuvPresent = true;
      }
    })
  }

  goToDettaglioPagamento(iuv: any):void{
    this.pagamentoSelezionato = this.findByIuv(this.listaPagamenti, iuv.target.value);
    this.messageService.sendPagamentoTributo(this.pagamentoSelezionato);
    localStorage.setItem("pagamentoSelezionato", JSON.stringify(this.pagamentoSelezionato));
  }

  goToSelezionaPagamento():void{
    this.stepIndex = 2;
    localStorage.removeItem("pagamentoSelezionato");
    this.pagamentoSelezionato = undefined;
  }

  goToServizi():void{
    window.location.href = this.confService.configurazione.linkServizi;
  }

  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }

  richiestaPosizioniTributarie():void{
    this.loading = true;
    this.paymentNoticesService.getPaymentNotices(this.initPaymentNotices()).subscribe({
        next: (res) => {
          this.listaPagamenti = res.mandatiPagamento;
          if(this.numeroTributo != undefined){
            //this.goToDettaglioPagamento(this.numeroTributo);
          }
          this.checkIuvPresent();
          this.listaPagamenti = this.listaPagamenti.map(pg => {
            let stato;
            if(pg.Importo === pg.Pagamenti){
              stato = 'Pagato';
            }else if(pg.Rate && pg.Rate[0].ImportoRidotto != null && pg.Rate[0].ImportoRidotto == pg.Pagamenti){
              stato = 'Pagato';
            }else if(pg.Importo - pg.Pagamenti == 0 ){
              stato = 'Pagato';
              pg.Importo = pg.Pagamenti;
            }else if(pg.Importo - pg.Pagamenti < 0 ){
              stato = 'F24 da Stampare';
            }else{
              stato = 'Da Pagare';
            }
            return Object.assign({}, pg , {
              stato: stato
            })
          });
          this.listaPagamentiNoSort = [...this.listaPagamenti];
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          if(err && err.error && err.error.detail){
            this.alertService.creaAlert(err.error.detail, "danger", "sticky", 5000, true)
          }else{
            this.alertService.creaAlert("Errore nel pagamento", "danger", "sticky", 5000, true)
          }
      }
    })
  }

  initPaymentNotices(): any{
      return {
        //codiceFiscale: 'CSTSFN57A16C342G',
        codiceFiscale: <string> this.userData.cf,
        codiceTributo: this.cdTributo
      }
  }

  applicaFiltri():void{
    this.listaPagamenti = [...this.listaPagamentiNoSort];
    if(this.formFilter.get('stato')?.value !== null){
      this.listaPagamenti = this.filterByStato(this.listaPagamenti);
    }
    if(this.formFilter.get('iuv')?.value !== null){
      this.listaPagamenti = this.filterByIuv(this.listaPagamenti);
    }
  }

  filterByStato(pagamenti: Array<Documento>): Array<Documento>{
    return pagamenti.filter(pg => {
      return pg.stato === this.formFilter.get('stato')?.value
    });
  }

  filterByIuv(pagamenti: Array<Documento>): Array<Documento>{
     return pagamenti.filter(pg => {
            return pg.Iuv === this.formFilter.get('iuv')?.value
     });
  }

  findByIuv(pagamenti: Array<Documento>, iuv: any): Documento{
    pagamenti = pagamenti.filter(pg => {return pg.Iuv === iuv});
    return <Documento>pagamenti.at(0);
  }

}
